import React from 'react';
import ReactDOM  from 'react-dom'
import {Route, Redirect } from 'react-router-dom'


class ProivateRoute extends React.Component {


    constructor(props) {
	super(props);

    }

    render() {

	const {component, authenticated} = this.props

	const Component = component
	if(authenticated === undefined)
	    return (<div></div>)
	else{
	    return (
		<Route render={props => authenticated  ? <Component {...props} /> : <Redirect to={{pathname: "/", 	state: { from: props.location }  }} />} />
	    )
	}
	    

    }
}

export default ProivateRoute;



// WEBPACK FOOTER //
// ./src/utils/PrivateRoute/PrivateRoute.jsx